import { useEffect } from "react";
import { setVerifiedBrands, setPendingMakeRequests } from "@workspace/listing-requirements";
import { listingsApi } from "./listings-api";

/**
 * Hydrates the verified-brand registry once on App mount. The validators in
 * `@workspace/listing-requirements` (`isVerifiedMake`, `canonicaliseVerifiedMake`)
 * fail OPEN before this resolves so the wizard renders without a flash of
 * "pick a verified make" errors — the API server's registry is the
 * authoritative gate (see `lib/brand-registry.ts` in the shared package).
 *
 * Also seeds the pending-brand-request set so the wizard can recognise a
 * draft whose make is awaiting admin approval (#1547) and so the inline
 * "Request '<typed>' as a new make" CTA can mark a brand as already-pending
 * without round-tripping back to the server.
 *
 * One fetch per page load is fine: ~210 rows × ~30 bytes = ~6 KB, with the
 * server setting `Cache-Control: public, max-age=300`.
 */
export function BrandRegistryBootstrap(): null {
  useEffect(() => {
    let cancelled = false;
    listingsApi
      .getBrands()
      .then((res) => {
        if (cancelled) return;
        setVerifiedBrands(res.brands || []);
        setPendingMakeRequests(res.pending || []);
      })
      .catch((err) => {
        // eslint-disable-next-line no-console
        console.warn("[brand-registry] failed to load verified brands", err);
      });
    return () => {
      cancelled = true;
    };
  }, []);
  return null;
}
